// XSLT İçe Aktarma diyaloğu (Talep #153).
// Kullanıcı bir e-belge XSLT'si seçer; içerik tarayıcıda LayoutJson öğelerine + detay
// bandına çevrilip mevcut dizayna yerleştirilir. Format şemaya gömülü değildir (değişken).
import { useState, useRef } from 'react';
import { s } from '../listPageStyles';
import { importXsltToLayout } from './xsltImport';

function readFileText(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result || ''));
    fr.onerror = () => reject(new Error(`${file.name} okunamadı`));
    fr.readAsText(file);
  });
}

export function XsltImportDialog({ open, onClose, onImport, printWidthMm, hasExisting }) {
  const [xsltName, setXsltName] = useState('');
  const [xmlName, setXmlName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const xsltRef = useRef(null);
  const xmlRef = useRef(null);

  if (!open) return null;

  const reset = () => { setXsltName(''); setXmlName(''); setError(''); setBusy(false); if (xsltRef.current) xsltRef.current.value = ''; if (xmlRef.current) xmlRef.current.value = ''; };
  const close = () => { reset(); onClose(); };

  const doImport = async () => {
    setError('');
    const xsltFile = xsltRef.current?.files?.[0];
    if (!xsltFile) { setError('Lütfen bir XSLT dosyası seçin.'); return; }
    if (hasExisting && !window.confirm('Mevcut tasarımdaki öğelerin yerine XSLT içeriği yerleştirilecek. Devam edilsin mi? (Geri almak için Ctrl+Z)')) return;
    setBusy(true);
    try {
      const xsltText = await readFileText(xsltFile);
      const xmlFile = xmlRef.current?.files?.[0];
      const sampleXml = xmlFile ? await readFileText(xmlFile) : '';
      // Render/ölçüm bir frame içinde yapılmalı (DOM'a iliştirilip ölçülüyor).
      await new Promise((r) => requestAnimationFrame(() => r()));
      const { elements, detailBand, meta } = importXsltToLayout(xsltText, { printWidthMm, sampleXml });
      if (!elements.length && !detailBand) { setError('XSLT içinden görsel öğe çıkarılamadı. XSLT geçerli mi?'); setBusy(false); return; }
      onImport(elements, detailBand, meta);
      close();
    } catch (e) {
      setError(e?.message || 'İçe aktarma başarısız.');
      setBusy(false);
    }
  };

  return (
    <div style={s.overlay} onClick={close}>
      <div style={{ ...s.modal, maxWidth: 540 }} onClick={(e) => e.stopPropagation()}>
        <div style={s.modalHeader}><h3 style={s.modalTitle}>XSLT İçe Aktar</h3></div>
        <div style={{ ...s.modalBody, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <p style={{ margin: 0, color: 'var(--text-primary)', fontSize: 13, lineHeight: 1.5 }}>
            Bir e-belge <b>XSLT</b> dosyası seçin; tasarımı bizim dizayn sistemimize çevrilir:
          </p>
          <ul style={{ margin: 0, paddingLeft: 18, color: 'var(--text-secondary)', fontSize: 12.5, lineHeight: 1.6 }}>
            <li>Statik metin, çizgi, kutu, görseller konumlarıyla gelir.</li>
            <li>Dinamik alanlar tanınırsa <b>Müşteri/Belge alanına bağlanır</b>; tanınmazsa <code>{'{alan}'}</code> yer tutucusu olur.</li>
            <li>Tekrar eden satır tablosu otomatik <b>Detay Bandı</b>na çevrilir (kolonlar eşlenir).</li>
          </ul>

          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>XSLT dosyası <span style={{ color: 'var(--danger, #dc2626)' }}>*</span></label>
            <input ref={xsltRef} type="file" accept=".xslt,.xsl,application/xml,text/xml" onChange={(e) => setXsltName(e.target.files?.[0]?.name || '')} style={{ fontSize: 13 }} />
            {xsltName ? <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>{xsltName}</div> : null}
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Örnek e-Fatura XML (isteğe bağlı)</label>
            <input ref={xmlRef} type="file" accept=".xml,application/xml,text/xml" onChange={(e) => setXmlName(e.target.files?.[0]?.name || '')} style={{ fontSize: 13 }} />
            <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 2 }}>
              {xmlName || 'Eklenmezse kanonik UBL-TR örnek faturası kullanılır (alanlar/kalemler bununla doğar). Kendi e-Fatura XML’inizi eklerseniz daha birebir olur.'}
            </div>
          </div>

          <p style={{ margin: 0, fontSize: 11.5, color: 'var(--text-secondary)' }}>
            İçe aktardıktan sonra eşlenemeyen alanları sağ panelden kolayca doğru alana bağlayabilirsiniz.
          </p>

          {error ? <div style={{ fontSize: 12, color: 'var(--danger, #dc2626)', background: 'rgba(220,38,38,0.08)', padding: '8px 10px', borderRadius: 6 }}>{error}</div> : null}
        </div>
        <div style={s.modalFooter}>
          <button style={s.btnPrimary} onClick={doImport} disabled={busy}>{busy ? 'İçe aktarılıyor…' : 'İçe Aktar'}</button>
          <button style={s.btnSecondary} onClick={close} disabled={busy}>İptal</button>
        </div>
      </div>
    </div>
  );
}
